import { render } from "./LimsInterface.vue?vue&type=template&id=2a62d879"
import script from "./LimsInterface.vue?vue&type=script&lang=js"
export * from "./LimsInterface.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__